import { useMemo } from 'react'
import { ETHEREUM_URL } from './config'
import { useEthers } from './EthersProvider'

export default function useProvider() {
    const { providers, getDefaultProvider } = useEthers()

    const { JsonRpcProvider } = providers || {}

    return useMemo(() => (
        ETHEREUM_URL ? (JsonRpcProvider && new JsonRpcProvider(ETHEREUM_URL)) : (getDefaultProvider && getDefaultProvider())
    ), [JsonRpcProvider, getDefaultProvider])
}
